import { produce } from 'immer'
import type { State } from '../typings'

export type CloseDialogAction = {
  type: 'closeDialog'
}

export const closeDialogProducer = produce<State>((draft) => {
  draft.activeDialog = undefined
})

export const closeDialogActionCreator = (): CloseDialogAction => ({
  type: 'closeDialog',
})
